import { render, staticRenderFns } from "./notice-event-detail.vue?vue&type=template&id=0ae234a7&scoped=true&"
import script from "./notice-event-detail.vue?vue&type=script&lang=js&"
export * from "./notice-event-detail.vue?vue&type=script&lang=js&"
import style0 from "./notice-event-detail.vue?vue&type=style&index=0&id=0ae234a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae234a7",
  null
  
)

export default component.exports